/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_ALLOCATIONS, GET_ALLOCATIONS } from 'src/actions/allocationActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const allocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ALLOCATIONS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_ALLOCATIONS: {
      const { allocations, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = allocations;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default allocationReducer;
